import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { MultiSelectField } from "../../../../common/components/forms/inputs/dropdown/MultiSelectSelectField";
import styles from "./CommunicationLogsFilterSidebar.module.scss";

interface ICommunicationLogsFilterSidebarProps {
  userOptions: { id: number; name: string }[];
  filterUserIds: number[] | null;
  onFilterUserIdsChange: (v: number[] | null) => void;
  emailTypeOptions?: { id: number; name: string }[];
  filterEmailTypes?: number[] | null;
  onFilterEmailTypesChange?: (v: number[] | null) => void;
  onClearAll: () => void;
  onClose: () => void;
}

export const CommunicationLogsFilterSidebar = ({
  userOptions,
  filterUserIds,
  onFilterUserIdsChange,
  emailTypeOptions,
  filterEmailTypes,
  onFilterEmailTypesChange,
  onClearAll,
  onClose,
}: ICommunicationLogsFilterSidebarProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>Потребител</div>
        <MultiSelectField
          options={userOptions}
          value={filterUserIds ?? []}
          onChange={onFilterUserIdsChange}
          filter
          filterBy="name"
          includeId={false}
          emptyMessage="Няма намерени потребители"
          width="100%"
        />
      </div>

      {emailTypeOptions && onFilterEmailTypesChange && (
        <>
          <div className={styles.separator} />
          <div className={styles.section}>
            <div className={styles.sectionTitle}>Тип имейл</div>
            <MultiSelectField
              options={emailTypeOptions}
              value={filterEmailTypes ?? []}
              onChange={onFilterEmailTypesChange}
              filter
              filterBy="name"
              includeId={false}
              emptyMessage="Няма намерени типове"
              width="100%"
            />
          </div>
        </>
      )}

      <div className={styles.buttonsSection}>
        <div className={styles.buttonGroup}>
          <DefaultButton label="Затвори" design="default" onClick={onClose} />
          <DefaultButton label="Изчисти всички" design="outline" onClick={onClearAll} />
        </div>
      </div>
    </div>
  );
};
